import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';

import ReadMore from '../read-more/read-more';

const ColumnContent = ({
  title,
  text,
  leadText,
  className,
  isHeading,
  equalColumnSize,
  switchColumn,
  moreContent,
  isAnimated,
}) => {
  useEffect(() => {
    if (isAnimated) {
      sal({ threshold: 0.25 });
    }
  }, [isAnimated]);

  const headingStyles =
    'font-heading text-sm uppercase lg:text-xl xl:text-2.5xl lg:col-span-2 mb-2 xl:mb-4 heading-title';
  let headingElement;
  if (isHeading) {
    headingElement = <h1 className={headingStyles}>{title}</h1>;
  } else {
    headingElement = <h3 className={headingStyles}>{title}</h3>;
  }

  return (
    <article
      className={`relative grid border-b-[1px] border-primary py-7 lg:grid-cols-2 lg:py-8 xl:py-10 ${className} ${
        leadText ? 'gap-4 lg:gap-8 xl:gap-10' : ''
      } ${!leadText && text && !title ? 'gap-4 lg:gap-8 xl:gap-10' : ''} ${
        equalColumnSize && leadText ? 'gap-14 lg:gap-8 xl:gap-10' : ''
      }`}
      {...(isAnimated
        ? {
            'data-sal': 'slide-up',
            'data-sal-duration': '1000',
            'data-sal-delay': '0',
            'data-sal-easing': 'ease',
          }
        : {})}
    >
      {title && headingElement}
      <div className={`flex flex-col justify-between ${switchColumn ? 'mobile:order-1' : ''}`}>
        {leadText && (
          <div
            className={`prose !leading-[1.35] ${
              !equalColumnSize
                ? 'text-lg lg:text-2xl lg:!leading-[1.25] xl:text-3.5xl'
                : 'text-sm lg:text-lg lg:!leading-[1.10] xl:text-2xl'
            }`}
          >
            {leadText}
          </div>
        )}
      </div>
      <div
        className={`${!equalColumnSize ? 'lg:ml-auto lg:max-w-[85%] xl:max-w-[75%]' : ''} ${
          !moreContent ? 'space-y-4 lg:space-y-6 ' : ''
        }`}
      >
        {text && (
          <div
            className={`prose !leading-[1.35]  ${
              equalColumnSize
                ? 'text-sm lg:text-lg xl:text-xl'
                : 'text-sm lg:text-lg lg:!leading-[1.75rem] xl:text-2xl'
            }`}
          >
            {text}
          </div>
        )}
        {moreContent && (
          <div className="text-sm lg:text-lg lg:!leading-[1.75rem] xl:text-2xl">
            <ReadMore className="relative" contentClassName="pt-4 lg:pt-6 space-y-4 lg:space-y-6">
              {moreContent}
            </ReadMore>
          </div>
        )}
      </div>
    </article>
  );
};

ColumnContent.propTypes = {
  title: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  leadText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  className: PropTypes.string,
  isHeading: PropTypes.bool,
  equalColumnSize: PropTypes.bool,
  switchColumn: PropTypes.bool,
  moreContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isAnimated: PropTypes.bool,
};
ColumnContent.defaultProps = {
  title: null,
  text: null,
  leadText: null,
  className: '',
  isHeading: false,
  equalColumnSize: false,
  switchColumn: false,
  moreContent: null,
  isAnimated: false,
};
export default ColumnContent;
